import { PropsWithChildren, useState } from "react";

import { useIsQaScannerEnabled } from "@components/QaReview/hooks/useIsQaScannerEnabled";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { SidebarView, SidebarViewContext } from "@providers/SidebarViewProvider/useSidebarView";

// Which view the report page's right column shows: the review panel or the table of contents. The
// clinician's own choice wins; it is dropped when they leave the review page or the report is
// completed, so the next visit starts from the default again.
export const SidebarViewProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const isQaScannerEnabled = useIsQaScannerEnabled();
  const isReviewPage = useIsReviewPage();
  const isReportCompleted = useIsReportCompleted();
  const [choice, setChoice] = useState<SidebarView | null>(null);

  if (choice !== null && (!isReviewPage || isReportCompleted)) setChoice(null);

  const defaultView: SidebarView = isQaScannerEnabled && !isReportCompleted ? "review" : "toc";

  return (
    <SidebarViewContext value={{ view: choice ?? defaultView, setView: setChoice }}>{children}</SidebarViewContext>
  );
};
